import React from 'react';
import newlogo from "../assets/images/new_logo-removebg.png";
import { SvgIcons } from './SvgIcons';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// pages whose footer opens with a CTA band (matches the design; keyed by route)
const FOOT_CTA = {
  '/about': <>Let's build the system that runs your <em>business.</em></>,
};

const ICONS = {
  linkedin: '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>',
}

const Footer = () => {

function svgIcon(name){ return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${ICONS[name]||''}</svg>`; }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const { pathname } = useLocation();
  const footCta = FOOT_CTA[pathname];

  return (

    <footer data-screen-label="Footer">
      {footCta && (
        <div className="foot-cta">
          <div className="wrap foot-cta-inner">
            <h3>{footCta}</h3>
            <Link to="/contact" className="btn btn-primary">Book a demo</Link>
          </div>
        </div>
      )}
      <div className="wrap">
        <div className="foot-grid">
          <div className="foot-brand">
            <Link to="/"><img src={newlogo} alt="MACOTECH" /></Link>
            <p>An integrated software company. Eight products, one platform — built to run your entire business.</p>
            <div className="foot-social">
              <a href="https://www.facebook.com/macotechsoftware/" target="_blank" rel="noreferrer" className="fs-ic" aria-label="Facebook">
                 <span dangerouslySetInnerHTML={{ __html: SvgIcons({ name: "facebook" }) }} />
              </a>
              <a href="https://www.x.com/MacoTechLtd" target="_blank" rel="noreferrer" className="fs-ic" aria-label="X (formerly Twitter)">
                <span dangerouslySetInnerHTML={{ __html: SvgIcons({ name: "x" }) }} />
              </a>
              <a href="https://www.linkedin.com/company/macotechsoftware/" target="_blank" rel="noreferrer" className="fs-ic" aria-label="LinkedIn">
              <span dangerouslySetInnerHTML={{ __html: SvgIcons({ name: "linkedin" }) }} />
              </a>
              <a href="https://www.instagram.com/macotechsoftware/" target="_blank" rel="noreferrer" className="fs-ic" aria-label="Instagram">
                 <span dangerouslySetInnerHTML={{ __html: SvgIcons({ name: "instagram" }) }} />
              </a>
            </div>
            <a className="foot-cert" href="https://www.startupindia.gov.in/" target="_blank" rel="noopener" title="DPIIT Recognised Startup">
              <span className="fc-seal"></span>
              {/* {i:award} */}
              <span className="fc-txt"><span className="fc-k">Recognised by Govt. of India</span><span className="fc-v">DPIIT · Startup India</span></span>
            </a>
          </div>
          <div className="foot-col">
            <h5>Products</h5>
            <HashLink smooth to="/product#hrms">HRMS</HashLink>
            <Link to="/on-the-go">ON THE GO — Face &amp; RFID Attendance</Link>
            <HashLink smooth to="/product#erp">ERP — Finance & GST</HashLink>
            <HashLink smooth to="/product#inventory">Inventory & POS</HashLink>
            <HashLink smooth to="/product#logistics">Transport & Logistics</HashLink>
            <HashLink smooth to="/product#hospitality">Hospitality PMS</HashLink>
            <HashLink smooth to="/product#asset">Asset Management</HashLink>
            <HashLink smooth to="/product#crm">CRM</HashLink></div>
          <div className="foot-col">
            <h5>Company</h5>
            <Link to="/about">About</Link>
            <Link to="/blog">Blog</Link>
            <HashLink smooth to="/#why">Why Maco</HashLink>
            <HashLink smooth to="/#testimonials">Customers</HashLink>
            <Link to="/contact">Contact</Link>
            <Link to="/pages">Modules</Link></div>
          <div className="foot-col">
            <h5>Get in touch</h5>
            <a href="mailto:sales@macotech.in">sales@macotech.in</a>
            <a href="tel:+918796991435">+91 87969 91435</a>
            <span>First Floor, Bungalow Plot 2, West Patel Nagar, New Delhi-110008 (India)</span>
            <a href="https://www.macotech.in" target="_blank" rel="noopener">www.macotech.in</a>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 MACOTECH — Integrated Software Company. All rights reserved.</span>
          <nav className="foot-legal" aria-label="Legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
